/* eslint-disable no-nested-ternary */
import React from 'react'
import PropTypes from 'prop-types'
import ButtonCta from '@components/atoms/button-cta'
import ModalVideo from '@components/modal-video/index'
import RendererRichText from '@components/renderers/render-rich-text'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import useStyles from './floating-box.styles'

const FloatingBox = (props) => {
  const {
    heading,
    eyebrow,
    supportiveCopy,
    supportiveCopyRich,
    longSupportiveCopy,
    buttonLabel,
    buttonLink,
    secondaryCtaText,
    secondaryCtaUrl,
    cardImage,
    cardVideo,
    cardVideoAssociatedImage,
    backgroundImage,
    cardHeading,
    cardSupportiveCopy,
    flipped,
    hideBox,
    componentID,
    media,
    card,
  } = props

  const _backgroundImage = card ? media || backgroundImage : backgroundImage
  const _cardImage = card ? card.image : cardImage || media
  const _cardHeading = card ? card.heading : cardHeading
  const _cardSupportiveCopy = card ? card.summary : cardSupportiveCopy
  const _cardVideo = card ? card.cardVideo : cardVideo
  const _cardVideoAssociatedImage = card
    ? card.cardVideoAssociatedImage
    : cardVideoAssociatedImage
  const styles = useStyles({ flipped, hideBox })

  const SupportiveCopy = () => (
    <>
      {supportiveCopyRich ? (
        <div className={styles.supportiveCopy}>
          <RendererRichText {...supportiveCopyRich} />
        </div>
      ) : (
        <p className={styles.supportiveCopy}>
          {longSupportiveCopy || supportiveCopy}
        </p>
      )}
    </>
  )

  return (
    <div className={styles.regionalCoach} id={componentID}>
      <div className={styles.splitContainer}>
        <div className={styles.imagerySection}>
          {_backgroundImage ? (
            <img
              className={styles.imagerySectionImg}
              alt=""
              src={_backgroundImage.url || '/images/coach-testimonial-bg.png'}
            />
          ) : (
            <div className={styles.backgroundOverlay} />
          )}
        </div>
      </div>

      <div className={styles.maxWidthContainer}>
        <div className={styles.introContainer}>
          <div>
            <Box mt={hideBox ? 0 : 10}>
              {eyebrow && (
                <Typography
                  variant="overline"
                  color="primary"
                  className={styles.featuredEyebrow}
                >
                  {eyebrow}
                </Typography>
              )}
              <h2 className={styles.heading}>{heading}</h2>
              <SupportiveCopy />
            </Box>
            {(buttonLink && buttonLabel) && (
              <div className={styles.ctaContainer}>
                <ButtonCta
                  className={styles.buttonPrimary}
                  href={buttonLink}
                  variant="contained"
                >{buttonLabel}
                </ButtonCta>
              </div>
            )
            }
          </div>
          {!hideBox && (
            <div className={styles.floatingBox}>
              <div className={styles.floatingBoxFlexContainer}>
                <div className={styles.floatingBoxImg}>
                  {(_cardVideo && _cardVideoAssociatedImage)
                    && (
                      <ModalVideo
                        modalVideo={_cardVideo}
                        imageAssociatedWithVideo={_cardVideoAssociatedImage}
                        isNested
                      />
                    )}
                  {(_cardImage && !_cardVideo) && (
                    <img
                      src={_cardImage && _cardImage.url}
                      alt={_cardImage.description ? _cardImage.description : ''}
                    />
                  )}
                </div>
                <div className={styles.floatingBoxCopyContainer}>
                  <h3 className={styles.floatingBoxHeading}>{_cardHeading}</h3>
                  <div className={styles.floatingBoxSupportiveCopy}>
                    {card?.summary
                      ? <RendererRichText {...card.summary} />
                      : _cardSupportiveCopy
                    }
                  </div>
                  {secondaryCtaText && secondaryCtaUrl && (
                    <ButtonCta
                      href={secondaryCtaUrl}
                      variant="text"
                      color="primary"
                    >
                      {secondaryCtaText}
                    </ButtonCta>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

FloatingBox.propTypes = {
  heading: PropTypes.string,
  eyebrow: PropTypes.string,
  supportiveCopy: PropTypes.string,
  supportiveCopyRich: PropTypes.object,
  longSupportiveCopy: PropTypes.string,
  buttonLabel: PropTypes.string,
  buttonLink: PropTypes.string,
  secondaryCtaText: PropTypes.string,
  secondaryCtaUrl: PropTypes.string,
  cardImage: PropTypes.object,
  cardVideo: PropTypes.object,
  cardVideoAssociatedImage: PropTypes.object,
  backgroundImage: PropTypes.object,
  cardHeading: PropTypes.string,
  cardSupportiveCopy: PropTypes.string,
  flipped: PropTypes.bool,
  hideBox: PropTypes.bool,
  componentID: PropTypes.string,
  media: PropTypes.object,
  card: PropTypes.object,
  theme: PropTypes.string,
}

FloatingBox.defaultProps = {}

export default FloatingBox
